import { useEffect, useState } from "react";

const MEETING_LINK_EVENT = "rayk-booking-meeting-link";
const nativeFetch = globalThis.fetch.bind(globalThis);

let installed = false;
let latestMeetingUrl: string | undefined;

function installMeetingLinkCapture() {
  if (installed) return;
  installed = true;

  globalThis.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const response = await nativeFetch(input, init);
    const method = (
      init?.method ?? (input instanceof Request ? input.method : "GET")
    ).toUpperCase();
    if (method !== "POST" || !response.ok) return response;

    const payload = await safeJson(response.clone());
    if (typeof payload.meetingUrl === "string" && payload.meetingUrl.startsWith("https://")) {
      latestMeetingUrl = payload.meetingUrl;
      window.dispatchEvent(new CustomEvent(MEETING_LINK_EVENT, { detail: latestMeetingUrl }));
    }
    return response;
  };
}

installMeetingLinkCapture();

export function MeetingLinkNotice() {
  const [meetingUrl, setMeetingUrl] = useState(latestMeetingUrl);

  useEffect(() => {
    const listener = (event: Event) => {
      const detail = (event as CustomEvent<string>).detail;
      if (detail) setMeetingUrl(detail);
    };
    window.addEventListener(MEETING_LINK_EVENT, listener);
    return () => window.removeEventListener(MEETING_LINK_EVENT, listener);
  }, []);

  if (!meetingUrl) return null;

  return (
    <aside className="meeting-link-notice" aria-live="polite">
      <strong>Dein Google-Meet-Link ist bereit.</strong>
      <a href={meetingUrl} target="_blank" rel="noreferrer">
        Google Meet öffnen
      </a>
    </aside>
  );
}

async function safeJson(response: Response): Promise<Record<string, unknown>> {
  try {
    return (await response.json()) as Record<string, unknown>;
  } catch {
    return {};
  }
}
